export const windowSize = {
  max480: `(max-width: 480px)`,
  min481: `(min-width: 481px)`,
  max576: `(max-width: 576px)`,
  max767: `(max-width: 767px)`,
  max991: `(max-width: 991px)`,
  max1200: `(max-width: 1200px)`,
  max1440: `(max-width: 1440px)`,
  min1441: `(min-width: 1441px)`,
  max1600: `(max-width: 1600px)`,
  max1920: `(max-width: 1920px)`,
  min1921: `(min-width: 1921px)`,
  max2560: `(max-width: 2560px)`,
  min2561: `(min-width: 2561px)`
};
